import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { sessionActions } from '../../../../../../store';
import { history } from '../../../../../../helpers';

export function useDeleteSession(sessionId: string | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);

  const handleDeleteSession = useCallback(async () => {
    if (!sessionId) return;
    setShowConfirmDeleteDialog(false);

    const { error } = await dispatch(
      sessionActions.deleteSession({
        sessionId,
        getAccessTokenSilently,
      }),
    );

    if (error) return;
    history.navigate('/dashboard');
  }, [dispatch, getAccessTokenSilently, sessionId]);

  return {
    showConfirmDeleteDialog,
    setShowConfirmDeleteDialog,
    handleDeleteSession,
  };
}
